import { memo } from "react";
import { useTransactionContext } from "../../TransactionProvider";
import CodeSnippet from "ui/molecules/CodeSnippet";

const SystemDecision = () => {
    const transaction = useTransactionContext();

    return (
        <CodeSnippet
            data={transaction.transactionDecision}
        />
    );
};

export default memo(SystemDecision);
